<template><recursos-pagina v-if="fechamento" /><legacy-dashboard v-else /></template>
<script>
import RecursosPagina from '@/modules/selo-fechamento/components/RecursosPagina.vue';
import LegacyDashboard from './ResourceDashboard.vue';
export default { name: 'ResourceDashboardClosingEntry', components: { RecursosPagina, LegacyDashboard }, computed: { fechamento() { const config=JSON.parse(localStorage.getItem('config') || '{}'); return config.fechamentoSelo === true; } } };
</script>
